import { TextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from '#src/pages/manage/security-breach/SecurityBreach.tsx';

export const Disclosure = () => {
  const { setValue } = useFormContext<FormValues>();
  return (
    <Controller
      name="disclosure"
      render={({ field, fieldState }) => (
        <TextField
          characterLimit={255}
          id="security-breach-disclosure"
          onChange={field.onChange}
          label="Have you notified, or do you intend to notify, any other third parties about the incident (including any hirers, candidates, or regulatory authorities)?"
          secondaryLabel="Optional"
          value={field.value}
          onClear={() => setValue('disclosure', '')}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
        />
      )}
    />
  );
};
